import React from 'react';
import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-metrics';
import { CloseButton } from '@spotahome/ui-library';

import FiltersIcon from './icons/Filters';

const SwiperNav = ({ onExitPressed, onFiltersPressed }) => {
  const handleFiltersPressed = () => {
    Metrics.ga.sendEvent('Matcher', 'open filters', 'button click');
    onFiltersPressed();
  };

  const handleExit = () => {
    Metrics.ga.sendEvent('Matcher', 'exit', 'button click');
    onExitPressed();
  };

  return (
    <div className="swiper-navigation">
      <span
        className="swiper-navigation__filters"
        onClick={handleFiltersPressed}
        role="button"
        tabIndex="0"
      >
        <FiltersIcon />
      </span>
      <CloseButton
        className="matcher-onboarding__exit"
        onClose={handleExit}
        size="small"
      />
    </div>
  );
};

SwiperNav.propTypes = {
  onExitPressed: PropTypes.func.isRequired,
  onFiltersPressed: PropTypes.func.isRequired
};

export default SwiperNav;
